import { cloneRule } from '../RecipeUtils.js';
import ConsentRecipes_1_0_0 from './ConsentRecipes_1_0_0.js';
const ConsentRecipeRules_1_1_0 = cloneRule(ConsentRecipes_1_0_0[0].rule);
ConsentRecipeRules_1_1_0.push({
    itemprop: 'text',
    itemtype: { type: 'string' },
    optional: true
});
const fileRefIndex = ConsentRecipeRules_1_1_0.findIndex(r => r.itemprop === 'fileReference');
ConsentRecipeRules_1_1_0[fileRefIndex].optional = true;
/**
 * @type {{name: string; rule: RecipeRule[]; $type$: string}}
 */
export const ConsentRecipe = {
    $type$: 'Recipe',
    name: 'Consent_1_1_0',
    rule: ConsentRecipeRules_1_1_0
};
const ConsentRecipes = [ConsentRecipe];
export default ConsentRecipes;
//# sourceMappingURL=ConsentRecipes_1_1_0.js.map